import ValueTracker from "../../../../../prop-trackers/value-tracker.js";
import SinglePropTracker from "../../../../../prop-trackers/single-prop-tracker.js";
import { ValueTracker as ForEachValueTracker } from "../../../../../prop-tracker-utils/for-each.js";

import ObjectTypes from "../../../../data-defs/object-types.js";

const KnownTypes = new Set(ObjectTypes);

class ObjectTypeGen extends ForEachValueTracker {
    constructor(evtCtx) {
        super();

        this._evtCtx = evtCtx;

        this._dataTracker = new ValueTracker();
        this._typeTracker = new SinglePropTracker();
        this._finalTypeTracker = new ValueTracker();

        const needsUpdate = () => this.protected_needsUpdate();
        this._dataTracker.listenNeedsUpdate(needsUpdate);
        this._typeTracker.listenNeedsUpdate(needsUpdate);
    }

    setValue(objectData) {
        if (objectData) {
            this._dataTracker.setValue(objectData);
            this._typeTracker.track(objectData, this._evtCtx.getEvents(objectData), "type");
        } else {
            this.deleteValue();
        }
    }

    deleteValue() {
        this._dataTracker.deleteValue();
        this._typeTracker.track();
    }

    protected_startUpdate() {
        this._dataTracker.update(({ prop: { newExists: dataExists } }) => {
            this._typeTracker.update(({ prop: { newValue: type } }) => {
                if (dataExists) {
                    type = KnownTypes.has(type) ? type : "Object3D";
                    this._finalTypeTracker.setValue(type);
                } else {
                    this._finalTypeTracker.deleteValue();
                }
            });
        });

        return this._finalTypeTracker.startUpdate();
    }

    protected_finishUpdate() {
        this._finalTypeTracker.finishUpdate();
    }
}

export default ObjectTypeGen;
